import { Image as ImageIcon, Sparkles, BookOpen, Infinity as InfinityIcon } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  ["capture", ImageIcon, "Capture", "Bring together your photos, videos and stories from every stage of life."],
  ["ai-organizes", Sparkles, "AI Organizes", "Our AI finds faces, moments and relationships, creating a seamless family timeline."],
  ["stories-come-alive", BookOpen, "Stories Come Alive", "Relive moments with enhanced photos, AI-powered narratives and immersive timelines."],
  ["pass-it-on", InfinityIcon, "Pass It On", "Share with loved ones today. Preserve for generations tomorrow."],
];

const COL = [
  "pr-4 sm:pr-8",
  "border-l border-[#1C2A3A] pl-4 sm:pl-8 lg:pr-8",
  "pr-4 sm:pr-8 lg:border-l lg:border-[#1C2A3A] lg:pl-8",
  "border-l border-[#1C2A3A] pl-4 sm:pl-8",
];

export const Features = () => (
  <section id="features" data-testid="section-features" className="relative">
    <div className="cl-container">
      <div className="grid grid-cols-2 gap-y-12 border-y border-[#1C2A3A]/70 py-14 lg:grid-cols-4 lg:py-16">
        {FEATURES.map(([key, Icon, title, body], i) => (
          <Reveal key={key} delay={i * 100} data-testid={`feature-${key}`} className={COL[i]}>
            <Icon size={30} strokeWidth={1} className="text-[#79B9FF]" aria-hidden="true" />
            <h3 className="mt-5 text-[15px] font-normal text-white sm:text-lg">{title}</h3>
            <p className="mt-3 max-w-[15rem] text-[13px] leading-relaxed text-[#9AAABD] sm:text-sm">{body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
